import styled from 'styled-components'

export const MapContainer = styled.figure`
	width: 100%;
	height: 500px;
	overflow: hidden;
`
